import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../../shared/services/auth.service';
import { SidenavService } from '../../shared/services/sidenav.service';
import { LanguageService } from '../../shared/services/language.service';
import { GCMService } from '../../shared/services/gcm.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { ScrImportFileComponent } from '../scr-import-file-dialog/scr-import-file-dialog.component';
import { ScrEditDialogComponent } from '../scr-edit-dialog/scr-edit-dialog.component';
import { ScrollControlService } from '../../shared/services/scroll-control.service';

@Component({
  standalone: false,
  selector: 'app-scr-management',
  templateUrl: './scr-management.component.html',
  styleUrls: ['./scr-management.component.css']
})
export class ScrManagementComponent implements OnInit, AfterViewInit {
  variables: any;
  isOpen: boolean = false;
  shouldPinSidenav: boolean = false;
  dataSource = new MatTableDataSource<any>([]);
  //displayedColumns1: string[] = ['practice', 'subPractice', 'codeName', 'costCenter', 'gcm0', 'gcm1', 'gcm2', 'gcm3', 'gcm4', 'gcm5', 'gcm6', 'gcm7', 'gcm8', 'gcm9', 'actions'];
  displayedColumns1: string[] = ['costCenter', 'gcm0', 'gcm1', 'gcm2', 'gcm3', 'gcm4', 'gcm5', 'gcm6', 'gcm7', 'gcm8', 'gcm9', 'actions'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private authService: AuthService,
    private sidenavService: SidenavService,
    private languageService: LanguageService,
    private gcmService: GCMService,
    public dialog: MatDialog,
    private router: Router,
    private formBuilder: FormBuilder,
    private scrollService: ScrollControlService
  ) { }

  ngOnInit(): void {
    this.scrollService.setScroll(true);

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.gcmService.getAllCECOS().subscribe((response: any) => {
      if (response) {
        this.dataSource.data = response;
      }
    });

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return data.practice.trim().toLowerCase().includes(filter) ||
        data.subPractice.trim().toLowerCase().includes(filter) ||
        data.codeName.trim().toLowerCase().includes(filter) ||
        data.costCenter.trim().toLowerCase().includes(filter);
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }

  editValues(element: any) {
    const data = {
      title: this.variables.editEntrance,
      element: {
        id: element.id,
        practice: element.practice,
        subPractice: element.subPractice,
        cecoCodeName: element.codeName,
        gcms: element.gcms,
        costCenter: element.costCenter
      },
    };

    let dialogRef = this.dialog.open(ScrEditDialogComponent, { data });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const i = this.dataSource.data.findIndex((ceco: any) => ceco.id === result.data.id);
        this.dataSource.data[i] = result.data;
        this.dataSource.data = [...this.dataSource.data];
      }
    });
  }

  importDataFromExcel() {
    const data = { title: this.variables.fromExcel1 };
    let dialogRef = this.dialog.open(ScrImportFileComponent, { data });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.dataSource.data = [...result.data];
      }
    });
  }

  searchCECOS(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filter;
  }
}
